import { Link } from 'react-router-dom';
import '../CSS/pages.css';

function NotFound() {
  return (
    <main className="page not-found-page">
      <section className="not-found-content">
        <p className="not-found-code">404</p>
        <p className="eyebrow">Page not found</p>
        <h1>This route does not lead anywhere.</h1>
        <p>
          The page may have moved or the address may be incorrect. Return to our
          services to keep exploring Emmapro Logistix.
        </p>
        <Link className="primary-action" to="/">
          Go to home page
        </Link>
      </section>
    </main>
  );
}

export default NotFound;
